export const FontFamily = {
  DM_SERIF_DISPLAY_REGULAR: 'DMSerifDisplay-Regular',
  HELVETICA_NOW_BOLD: 'HelveticaNowDisplay-Black',
  HELVETICA_NOW_REGULAR: 'HelveticaNowDisplay-Regular',
  HELVETICA_NOW_THIN: 'HelveticaNowDisplay-Light',
  LIBRE_FRANKLIN_REGULAR: 'LibreFranklin-Regular',
  NEUE_HAAS_DISPLAY_BLACK: 'NeueHaasDisplay-Black',
  NEUE_HAAS_DISPLAY_BOLD: 'NeueHaasDisplay-Bold',
  NEUE_HAAS_DISPLAY_MEDIUM: 'NeueHaasDisplay-Mediu',
  NEUE_HAAS_DISPLAY_ROMAN: 'NeueHaasDisplay-Roman',
  NEUE_HAAS_DISPLAY_THIN: 'NeueHaasDisplay-Thin',
  NEUE_HAAS_OUTLINE_NUMBERS: 'NeueHaasDisplay-Outline-Numbers',
};
